'use client';

export const useAuthSession = () => {

	// useEffect(() => {
	// 	if (error) {
	// 		authStore.clearAuth();
	// 		router.replace(AppRoutes.auth.login);

	// 		return;
	// 	}

	// 	if (isSuccess) {
	// 		const { accessToken, session } = data;
	// 		authStore.setAuth({
	// 			id:        session.candidateId,
	// 			email:     session.email,
	// 			firstName: session.firstName,
	// 			lastName:  session.lastName,
	// 		}, accessToken);
	// 	}
	// }, [ error, isSuccess, authStore, router, data ]);

	// return {
	// 	data,
	// 	error,
	// 	isLoading,
	// 	isSuccess,
	// };
};
